<template>
    <div class="relative">
        <component
            :is="buttonComponent"
            class="button-drawer cursor-pointer"
            type="button"
            :class="buttonClasses"
            :to="buttonRoute"
            v-bind="buttonHref ? {href: buttonHref} : {}"
            @click="buttonClick(buttonClickParams)"
        >
            <span class="flex flex-row space-x-2 items-center">
                <span v-if="buttonIcon">
                    <component :is="iconComponent" :marginAuto="false" class="text-purple-600"></component>
                </span>
                <span>{{ buttonText }}</span>
            </span>
        </component>
        <span
            v-if="buttonBadge"
            class="absolute end-0 top-2 inline-flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white"
        >
            {{ buttonBadge }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'ButtonDrawer',
    props: {
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonHref: {
            required: false,
            type: String,
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonIcon: {
            required: false,
            type: String,
            default: null,
        },
        buttonBadge: {
            required: false,
            type: Number,
            default: 0,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        iconComponent() {
            return 'icon-' + this.buttonIcon;
        },
        buttonComponent() {
            if (this.buttonRoute) return 'router-link';
            if (this.buttonHref) return 'a';
            return 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['-mx-3 block rounded-lg px-3 py-2 text-base font-bold leading-7 text-gray-900 hover:bg-gray-50'] = true;
            return cls;
        },
    },
};
</script>
